<template>
    <div>
        <preview-component-factory
            v-for="registrationData,index in registeredComponents"
            :key="registrationData.tempId ? registrationData.tempId : registrationData.componentId"
            :registrationData="registrationData"
        ></preview-component-factory>
    </div>
</template>

<script>

    import PreviewComponentFactory from "./PreviewComponentFactory";
    import ComponentsManager from "../../components/pagesbuilder/dynamic-components/ComponentsManager";

    export default {
        mixins: [ComponentsManager],
        components : {
            PreviewComponentFactory
        }
    }
</script>
